import api from "./axios";

// Public — contact form
export const submitLead = (data) =>
  api.post("/api/leads/", data);

// Admin
export const adminGetLeads = (params) =>
  api.get("/api/admin/leads/", { params });
  // params: status, visitor_type, assigned_to, priority, date_from, date_to, search, page, page_size

export const adminGetLead = (id) =>
  api.get(`/api/admin/leads/${id}/`);

export const adminUpdateLead = (id, data) =>
  api.put(`/api/admin/leads/${id}/`, data);

export const adminGetLeadStats = () =>
  api.get("/api/admin/leads/stats/");

export const adminExportLeads = (params) =>
  api.get("/api/admin/leads/export/", { params });

// Follow-ups
export const getFollowUps = (leadId) =>
  api.get(`/api/admin/leads/${leadId}/follow-ups/`);

export const createFollowUp = (leadId, data) =>
  api.post(`/api/admin/leads/${leadId}/follow-ups/`, data);

// Activities
export const getActivities = (leadId) =>
  api.get(`/api/admin/leads/${leadId}/activities/`);

export const createActivity = (leadId, data) =>
  api.post(`/api/admin/leads/${leadId}/activities/`, data);